import {
  AMOUNT_ROWS_GET_BLOCKED_FOLLOWERS,
  CommunitiesService
} from '@space-shell/common/services/communities'
import { useInfiniteQuery } from '@tanstack/react-query'

import { useUnbanMemberCommunityModal } from '../../unbanMemberCommunityModal/context/useUnbanMemberCommunityModal'

export const useGetBlockedFollowers = (query: string, communityIdParam = 0) => {
  const { community } = useUnbanMemberCommunityModal()

  const idCommunity = communityIdParam ? communityIdParam : community?.id

  return useInfiniteQuery(
    ['getBlockedFollowers'],
    ({ pageParam }) =>
      CommunitiesService.getBlockedFollowers({ communityId: idCommunity, pageParam, query }),
    {
      enabled: !!idCommunity && idCommunity !== 0,
      /* istanbul ignore next */
      getNextPageParam: (lastPage) => {
        if (lastPage.data.length === 0 || lastPage.size <= AMOUNT_ROWS_GET_BLOCKED_FOLLOWERS)
          return false

        if (lastPage.data.length > 0 && lastPage.data.length === AMOUNT_ROWS_GET_BLOCKED_FOLLOWERS)
          return lastPage.page + 1

        return false
      }
    }
  )
}
